import { Box, Stack, Typography } from '@mui/material';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import BetSlot from './BetSlot';
import { useContext, useEffect, useState } from 'react';
import { GameContext } from '../../../contexts/GameContext';
import { CSSTransition } from 'react-transition-group';

export interface CardInterface {
    singer: string;
    title: string;
    year: number;
    width: string;
    height: string;
    isIcon: boolean;
    doubleFreeSpot: boolean;
}

const Card = (props: CardInterface) => {
    const background = 'url(/images/cards/gradient.png)';
    const gameContext = useContext(GameContext);
    const [randomXBackground, setRandomXBackground] = useState(0);
    const [showCard, setShowCard] = useState(false);
    const [showSongInfo, setShowSongInfo] = useState(false);
    const imageWidth = 3000;

    useEffect(() => {
        setRandomXBackground(Math.floor(Math.random() * imageWidth));
        setShowCard(true);
    }, [gameContext.gameId]);

    return (
        <Stack
            direction={'row'}
            sx={{
                width: 'auto',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: { xs: '15px', sm: '50px' },
                position: 'relative',
            }}
        >
            {props.doubleFreeSpot ? <BetSlot id={`${props.year}_before`} /> : ''}

            <CSSTransition in={showCard} timeout={500} classNames="" unmountOnExit>
                {(state) => (
                    <Box
                        onClick={() => setShowSongInfo((prev) => !prev)}
                        sx={{
                            width: props.width,
                            height: props.height,
                            backgroundImage: background,
                            backgroundSize: `${imageWidth}px 1000px`,
                            backgroundPosition: `-${randomXBackground}px 0px`,
                            backgroundRepeat: 'repeat',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            border: '1px solid black',
                            opacity: state === 'entered' ? 1 : 0,
                            transform: state === 'entered' ? 'scale(1)' : 'scale(0.8)',
                            transition: 'opacity 500ms, transform 500ms',
                            position: 'relative',
                            zIndex: 1,
                            '@keyframes tapHint': {
                                '0%, 100%': { transform: 'scale(1)', opacity: 0.55 },
                                '50%': { transform: 'scale(1.18)', opacity: 1 },
                            },
                        }}
                    >
                        <TouchAppIcon
                            sx={{
                                position: 'absolute',
                                top: 2,
                                right: 2,
                                fontSize: '0.85rem',
                                color: 'rgba(255,255,255,0.85)',
                                filter: 'drop-shadow(0 0 3px rgba(193,145,255,0.7))',
                                animation: 'tapHint 1.6s ease-in-out infinite',
                                transformOrigin: 'center',
                                pointerEvents: 'none',
                                display: { xs: showSongInfo ? 'none' : 'block', sm: 'none' },
                                zIndex: 2,
                            }}
                        />
                        <Stack
                            spacing={{ xs: 0, sm: 5 }}
                            sx={{
                                width: '100%',
                                height: '100%',
                                justifyContent: { xs: showSongInfo ? 'space-between' : 'center', sm: 'center' },
                                alignItems: 'center',
                                padding: { xs: '4px', sm: 0 },
                                boxSizing: 'border-box'
                            }}
                        >
                            <Typography
                                variant={'body1'}
                                sx={{
                                    color: 'white',
                                    textShadow: '0 0 8px rgba(193, 145, 255, 0.3)',
                                    textAlign: 'center',
                                    display: { xs: showSongInfo ? 'block' : 'none', sm: 'block' },
                                    fontSize: { xs: '0.7rem', sm: '1rem' },
                                    lineHeight: { xs: 1.1, sm: 1.5 },
                                    wordBreak: 'break-word'
                                }}
                            >
                                {props.singer}
                            </Typography>
                            <Typography
                                variant={'h2'}
                                sx={{
                                    color: '#fff',
                                    textAlign: 'center',
                                    fontSize: { xs: '1.75rem', sm: '3.75rem' },
                                    display: { xs: showSongInfo ? 'none' : 'block', sm: 'block' }
                                }}
                            >
                                {props.year}
                            </Typography>
                            <Typography
                                variant={'body1'}
                                sx={{
                                    color: '#fff',
                                    textShadow: '0 0 8px rgba(193, 145, 255, 0.3)',
                                    textAlign: 'center',
                                    display: { xs: showSongInfo ? 'block' : 'none', sm: 'block' },
                                    fontSize: { xs: '0.7rem', sm: '1rem' },
                                    lineHeight: { xs: 1.1, sm: 1.5 },
                                    wordBreak: 'break-word'
                                }}
                            >
                                {props.title}
                            </Typography>
                        </Stack>
                    </Box>
                )}
            </CSSTransition>

            {!props.isIcon ? <BetSlot id={`${props.year}_after`} /> : ''}
        </Stack>
    );
};

export default Card;
